import { CCloseButton } from './CCloseButton.js';

const CCloseButtonPlugin = {
    install: (app) => {
        app.component(CCloseButton.name, CCloseButton);
    },
};

export { CCloseButton, CCloseButtonPlugin };
//# sourceMappingURL=index.js.map
